import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionService } from './session.service';
import { SideBarService } from './side-bar.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    public sessionService: SessionService
    ,public sidebarService: SideBarService) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        
        if (error.status === 401) {
          this.sidebarService.currentPath.next('Inicio');
          this.sidebarService.toggler.next(false);
          this.sessionService.logOut();
          return throwError(`Lo sentimos, la sesión ha expirado`);
        }
        
        let errorMsg = '';
        if (error.error && error.error instanceof ErrorEvent) {
          errorMsg = error.error.message;
        } else {
          errorMsg = error?.error?.error_description || error.message;
        }
        
        return throwError(errorMsg);
      })
    );
  }
}
